import { Page, View, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  AgendaSpeaker,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { getImageSrc } from '@utils/fn';
import { APP_HOST } from '@utils/apiHooks';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface AllSpeakerPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
  agendaSpeakers: AgendaSpeaker[];
}

const AllSpeakerPage = ({
  event,
  footer,
  agendaSpeakers,
}: AllSpeakerPageProps) => {
  const { t } = useTranslation();

  const filteredSpeakers = agendaSpeakers?.filter(
    speaker => speaker?.company?.logo && speaker?.images?.picture
  );

  return (
    <Page size={{ width: 1440, height: 800 }} style={styles.page}>
      <View style={styles.fullWidthContainer}>
        <View style={styles.galleryContainer}>
          <View style={{ width: 220, height: 140 }}>
            <Text style={styles.pageTitle}>{t('speaker')}</Text>
            <View
              style={{
                ...globalStyles.lineBar,
                alignSelf: 'flex-start',
                borderColor: event?.design?.themeColor ?? 'black',
                marginTop: 20,
                marginLeft: 0,
                marginBottom: 5,
                width: 140,
              }}
            />
          </View>

          {(filteredSpeakers || []).map((speaker, index) => {
            const companyLogoSrc = getImageSrc(speaker?.company?.logo);
            const speakerImageSrc = getImageSrc(speaker?.images?.picture);

            if (
              (index + 1) % 29 === 0 ||
              index + 1 === filteredSpeakers.length
            ) {
              return (
                <View
                  key={`speaker-${speaker.profile}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 220,
                    height: 110,
                  }}
                  wrap={false}
                >
                  <Link
                    src={`${APP_HOST}/events/${event?.slug}${t('speakers-url')}`}
                    style={{
                      ...styles.button,
                      backgroundColor: event?.design?.themeColor ?? '#000',
                      color: 'white',
                      width: 220,
                    }}
                  >
                    {t('show-all-speakers')}!
                  </Link>
                </View>
              );
            } else {
              return (
                companyLogoSrc &&
                speakerImageSrc && (
                  // Add wrap false so speaker don't get cut
                  <View style={styles.speakerItemWrapper} wrap={false}>
                    <View style={styles.leftColumn}>
                      <SafeImage
                        key={index}
                        style={styles.speakerImage}
                        src={speakerImageSrc}
                      />
                      <SafeImage
                        key={index}
                        style={styles.companyLogoImage}
                        src={companyLogoSrc}
                      />
                    </View>

                    <View style={styles.rightColumn}>
                      <Text style={styles.speakerNameText}>
                        {speaker?.first_name} {speaker?.last_name}
                      </Text>
                      <Text style={styles.speakerCompanyText}>
                        {speaker?.company?.name}
                      </Text>
                      <Text style={styles.speakerJobTitleText}>
                        {speaker?.job?.title}
                      </Text>
                    </View>
                  </View>
                )
              );
            }
          })}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default AllSpeakerPage;
